import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, Button, Grid } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";

import { fetchFinancialAssetType, updateFinancialAssetType } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function FinancialAssetTypeEditPage() {
  const { businessDomainId, financialAssetTypeId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [form, setForm] = useState({ financialAssetTypeName: "", financialAssetTypeDescription: "" });
  const [fullData, setFullData] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const d = await fetchFinancialAssetType(financialAssetTypeId);
        setFullData(d);
        setForm({
          financialAssetTypeName: d.financialAssetTypeName || "",
          financialAssetTypeDescription: d.financialAssetTypeDescription || "",
        });
      } catch (e) { notify.apiError(e); }
    })();
  }, [financialAssetTypeId]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = { ...fullData, ...form };
      await updateFinancialAssetType(payload);
      notify.success(t("message.update.success"));
      navigate(`/design/${businessDomainId}/financial-asset-types/${financialAssetTypeId}`);
    } catch (err) { notify.apiError(err); }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>{t("financialAssetType.edit.title")}</Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <TextField fullWidth required multiline label={t("financialAssetType.name")}
              name="financialAssetTypeName" value={form.financialAssetTypeName} onChange={handleChange} />
          </Grid>
          <Grid size={12}>
            <TextField fullWidth multiline rows={3} label={t("financialAssetType.description")}
              name="financialAssetTypeDescription" value={form.financialAssetTypeDescription} onChange={handleChange} />
          </Grid>
        </Grid>
        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">{t("common.save")}</Button>
          <Button variant="outlined" onClick={() => navigate(`/design/${businessDomainId}/financial-asset-types/${financialAssetTypeId}`)}>{t("common.cancel")}</Button>
        </Box>
      </Box>
    </Box>
  );
}
